export const conversationStep = [
    { target: '#conversationlist', content: 'View all your conversation threads in this list. Tap on any conversation to resume chat seamlessly.', disableBeacon: true },
    { target: '#editconversation', content: "Click the edit icon to rename your conversation.", disableBeacon: true },
    { target: '#deleteconversation', content: "Click the delete icon to remove the conversation and its historys.", disableBeacon: true },
]

export const noConversation = { target: '#noconversation', content: "No conversations created yet.Click on new conversation button to create new conversation.", disableBeacon: true }

export const settingButton = { target: '#settingsbutton', content: 'Click the Settings button to adjust temperature and manage top-ranked pages.', disableBeacon: true }

export const chatSectionStep = [
    { target: '#chathistory', content: 'Toggle the button to view or hide the chat history', disableBeacon: true },
    { target: '#selectmodel', content: 'Select the GPT model from dropdown provided', disableBeacon: true },
    { target: '#outlined-multiline-flexible', content: 'Provide the content to the text field to interact with the model', disableBeacon: true },
    { target: '#micicon', content: 'Ask the question by speaking into the microphone to interact with the model', disableBeacon: true },
]

export const vanillaVMSteps = [{ target: '#list-item-0', content: 'Click on Vanilla LLM to start a chat and engage with the model.', disableBeacon: true },
{ target: '#pi', content: "Toggle 'Enable PII Redaction' to prevent sending personal information.", disableBeacon: true }
]
export const userFormatSteps = [
    { target: '#prompt', content: "Click the add icon to enter a prompt value and interact with the model.", disableBeacon: true },
    { target: '#promptcheckbox', content: "Click the checkbox to select the prompt and ask the corresponding question. The answer will be provided based on the data in the prompt", disableBeacon: true },
    { target: '#editicon', content: 'Click the edit icon to modify the prompt value.', disableBeacon: true },
    { target: '#deleteicon', content: 'Click the delete icon to remove the prompt value.', disableBeacon: true },
]
export const userFormatElseStep = { target: '#prompt', content: "Click the add icon to enter a prompt value and interact with the model.", disableBeacon: true }

export const promptsStep = [
    { target: '#saved', content: 'Saved queries from the chats.', disableBeacon: true },
    { target: '#copyicon', content: 'Clik on the copy icon to copy the saved query.', disableBeacon: true },
    { target: '#savedediticon', content: 'Click the edit icon to modify the saved query.', disableBeacon: true },
    { target: '#saveddeleteicon', content: 'Click the delete icon to remove the saved query.', disableBeacon: true }]

export const promptElseStep = { target: '#saved', content: 'Saved quesries from the chats', disableBeacon: true }

export const docsSteps = [{ target: '#list-item-1', content: 'Click on DOCS to extract information from PDF, text, and DOC files, or to upload files.', disableBeacon: true },
{ target: '#top', content: 'Toggle between the top 3 ranked pages to get answers based on the top 3 results.', disableBeacon: true },
{ target: '#pi', content: "Toggle 'Enable PII Redaction' to prevent sending personal information.", disableBeacon: true }]

export const filesSteps = [
    { target: '#uploadfileicon', content: 'Click on add icon to upload or view PDF, text, and DOC files to interact with the model.', disableBeacon: true },
    { target: '#filechecked', content: 'Click the checkbox to select the file and ask the corresponding question. The answer will be provided based on the data in the file.', disableBeacon: true },
    { target: '#deletefile', content: 'Click the delete icon to remove the file.', disableBeacon: true },
    { target: '#shareicon', content: "Click the share icon to share the file with other users by entering their email ID.", disableBeacon: true },
    { target: '#infoicon', content: "Click the info icon to view the list of users who have access to the shared file.", disableBeacon: true }
]
export const noFilesSteps = { target: '#uploadfile', content: 'Click the add icon to upload or view PDF, text, and DOC files to interact with the model.', disableBeacon: true }

export const sharedFilesSteps = [
    { target: '#shareddoc', content: 'Documents shared by you or other users.', disableBeacon: true },
    { target: '#copresenticon', content: 'Click the icon to view who has shared the file with the user.', disableBeacon: true },
    { target: '#deleteshared', content: 'Click the delete icon to remove the shared file.', disableBeacon: true }
]

export const noSharedFilesSteps = { target: '#shareddoc', content: 'List of the documents shared by other users.', disableBeacon: true }

export const imageSteps = [{ target: '#list-item-2', content: 'Click on Image to extract information from images in PNG, JPG, or JPEG formats, or to upload an image.', disableBeacon: true },
{ target: '#uploadfileicon', content: 'Click the add icon to upload an image in the allowed formats: PNG, JPG, or JPEG.', disableBeacon: true },
{ target: '#filechecked', content: 'Click the checkbox to select the image and ask the corresponding question. The answer will be provided based on the uploaded image.', disableBeacon: true },
{ target: '#clickonimage', content: "Click on the text to view the image.", disableBeacon: true },
{ target: '#deletefile', content: 'Click the delete icon to remove the uploaded image', disableBeacon: true }]

export const imageElseSteps = { target: '#uploadfile', content: 'Click the Upload file button to upload an image in the allowed formats: PNG, JPG, or JPEG.', disableBeacon: true }

export const excelElseFileSteps = { target: '#uploadfile', content: 'Click the Upload file button to upload the excel file', disableBeacon: true }

export const collectionSteps = [
    { target: '#list-item-3', content: 'Click on Collection to upload the combination of PDF and Image files.', disableBeacon: true },
    { target: '#uploadfileicon', content: 'Click the add icon to create a new collection.', disableBeacon: true },
    { target: '#collectioncheckbox', content: '"Click the checkbox to select the collection, then ask the corresponding question. The answer will be provided based on the data in the selected collection.', disableBeacon: true },
    { target: '#editcollection', content: 'Click the edit icon to upload the files and images to the collection.', disableBeacon: true },
    { target: '#deletecollectionicon', content: 'Click the delete icon to remove the collection.', disableBeacon: true }
]

export const databaseSteps = [{ target: '#list-item-4', content: 'Click on the database to upload the database or take a preview of the uploaded database.', disableBeacon: true },
{ target: '#uploadfileicon', content: 'Click the add icon to upload the database.', disableBeacon: true },
{ target: '#filechecked', content: "When the checkbox is selected, the database will be selected, and a 'Data Preview' button will appear in the Chat section", disableBeacon: true },]

export const databaseElseSteps = { target: '#uploadfile', content: 'Click the Upload file button to upload the database.', disableBeacon: true }

export const neo4jSteps = [
    { target: '#list-item-5', content: 'Click on Neo4j to view graphical representations of charts.', disableBeacon: true },
    { target: '#uploadfileicon', content: 'Click the add icon to upload the file.', disableBeacon: true },
    { target: '#filechecked', content: 'Click the checkbox to select the file, then ask the corresponding question. The answer will be provided based on the data in the selected file.', disableBeacon: true },
    { target: '#clickontext', content: 'Click on the file name to view the details in the format of Details, Schema, and Data.', disableBeacon: true },
    { target: '#deletefile', content: 'Click the delete icon to remove the file.', disableBeacon: true }]

export const neo4jelseSteps = { target: '#uploadfile', content: 'Click the upload file button to upload the file.', disableBeacon: true }


export const exceFileSteps = [
    { target: '#list-item-6', content: 'Click on Excel to extract information from Excel files or to upload an Excel file.', disableBeacon: true },
    { target: '#uploadfileicon', content: 'Click the add icon to upload the excel file', disableBeacon: true },
    { target: '#filechecked', content: "When the checkbox is selected, the Excel file will be selected, and a 'Data Preview' button will appear in the Chat section.", disableBeacon: true },]
    

export const allTypeSteps = [{
    target: '#list-item-0',
    content: 'Click on Vanilla LLM to start a chat and engage with the model.',
    disableBeacon: true
},
{
    target: '#list-item-1',
    content: 'Click on DOCS to extract information from PDF, text, and DOC files, or to upload files.',
    disableBeacon: true
}
    ,
{
    target: '#list-item-2',
    content: 'Click on Image to extract information from images in PNG, JPG, or JPEG formats, or to upload an image.',
    disableBeacon: true
},
{
    target: '#list-item-3',
    content: 'Click on Collection to upload the combination of PDF and Image files. ',
    disableBeacon: true
},
{
    target: '#list-item-4',
    content: 'Click on the database to upload the database or take a preview of the uploaded database.',
    disableBeacon: true
},
{
    target: '#list-item-5',
    content: 'Click on Neo4j to view graphical representations of charts.',
    disableBeacon: true
},
{
    target: '#list-item-6',
    content: 'Click on Excel to extract information from Excel files or to upload an Excel file.',
    disableBeacon: true
},
{
    target: '#logout',
    content: 'Click on the logout icon to exit the screen and log out.',
    disableBeacon: true
}
]

export const styles = {
    tooltip: {
        fontSize: '12px'
    },
    tooltipContent: {
        padding: '0px'
    },
    buttonClose: {
        display: 'none'
    },
    options: { zIndex: 15000 },
    buttonNext: { backgroundColor: "#fd5f07", color: "#fff" },
    buttonBack: { color: "#fd5f07" },
    buttonSkip: { color: "#fd5f07" },
}

export const locale = { skip: "Close", next: "Next", back: "Back", last: "Finish" }